import { Component, signal } from "@angular/core";
import { SeSearchComponent } from "./se.search.component";
import { SeSearchResultsComponent } from "./tile.search.results.component";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25LoadingInlineModule } from "../../s25-loading/s25.loading.inline.module";

/**
 * Full page component for Student Engagement search functionality.
 * This page allows searching for SE organizations and events with full features.
 */
@TypeManagerDecorator("s25-ng-se-search-page")
@Component({
    selector: "s25-ng-se-search-page",
    template: `
        @if (isLoading()) {
            <s25-ng-loading-inline-static></s25-ng-loading-inline-static>
        }
        @if (isInit()) {
            <div class="page-wrapper">
                <section class="hero-search-section">
                    <div class="hero-content">
                        <h1 class="hero-title">Student Engagement Search</h1>
                        <p class="hero-subtitle">Find organizations and events that match your interests</p>
                        <div class="search-container">
                            <s25-ng-se-search #searchComponent></s25-ng-se-search>
                        </div>
                    </div>
                </section>

                <s25-ng-se-search-results
                    [results]="searchComponent.results()"
                    [resultsCount]="searchComponent.resultsCount()"
                    [hasSearched]="searchComponent.hasSearched()"
                    [isSearching]="searchComponent.isSearching()"
                    [searchType]="searchComponent.searchType()"
                    [currentPage]="searchComponent.currentPage()"
                    [pageSize]="searchComponent.pageSize()"
                    (loadMore)="searchComponent.onLoadMore()"
                    (pageChange)="searchComponent.onPageChange($event)"
                ></s25-ng-se-search-results>
            </div>
        }
    `,
    styles: `
        .hero-search-section {
            position: relative;
            min-height: 300px;
            background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
            background-size: cover;
            background-position: center;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 2rem;
            border-radius: 4px;
        }

        .hero-content {
            position: relative;
            z-index: 2;
            text-align: center;
            padding: 2rem;
            max-width: 800px;
            width: 100%;
        }

        .hero-title {
            font-size: 2.5rem;
            color: #fff;
            margin: 0 0 0.5rem 0;
            font-weight: 700;
        }

        .hero-subtitle {
            font-size: 1.125rem;
            color: rgba(255, 255, 255, 0.9);
            margin: 0 0 2rem 0;
        }

        .search-container {
            display: flex;
            justify-content: center;
        }

        .se-search-page {
            max-width: 1400px;
            margin: 0 auto;
            padding: 0 1rem 2rem;
        }

        @media (max-width: 768px) {
            .hero-title {
                font-size: 2rem;
            }

            .hero-subtitle {
                font-size: 1rem;
            }

            .hero-content {
                padding: 1.5rem;
            }

            .se-search-page {
                padding: 0 0.5rem 1rem;
            }
        }
    `,
    standalone: true,
    imports: [SeSearchComponent, SeSearchResultsComponent, S25LoadingInlineModule],
})
export class SeSearchPageComponent {
    isLoading = signal(true);
    isInit = signal(false);

    constructor() {
        void this.init();
    }

    private async init(): Promise<void> {
        // Add any initialization logic here (permissions, etc.)
        this.isLoading.set(false);
        this.isInit.set(true);
    }
}
